import React, { useState } from 'react';
import ContactUs from './components/ContactUs';
import Divider from './components/Divider';
import Profile from './components/Profile';
import Services from './components/Services';
import './styles/styles.scss';
function App() {
  // const [hover, setHover] = useState(false);
  return (
    <div className="home">
      <div
        className="logo"
        // onMouseEnter={() => {
        //   setHover(true);
        // }}
        // onMouseLeave={() => {
        //   setHover(false);
        // }}
      >
        <img className="logo-title" src="/main.png" alt="왼손잡이들 로고" />
        {/*<span className="logo-since">since 2019</span>*/}
        {/* <div className={hover ? 'description-hover' : 'description'}>
          안녕하세요
          <br />
          <br />
          왼손잡이들은 최소한의 인원으로 일상 속의 문제들을 저희들만의 방법으로
          풀어나가는 팀입니다.
          <br />
          <br />
          왼손잡이들은 서비스를 진심으로 사랑하는 사람들이 모인 팀이며,
          사람들에게 좋은 서비스를 제공하는 것을 추구합니다.
          <br />
          <br />
          서비스를 진정으로 사랑하는 기획자, 개발자, 디자이너 분들의 참여를
          환영합니다.
          <div className="sign">
            <img className="sign-img" src="/류동훈.png" alt="류동훈 싸인" />
          </div>
        </div> */}
      </div>
      <Divider title="services." />
      {contents.map((data, i) => {
        return <Services content={data} key={i} />;
      })}
      <Divider title="main members." />
      {profileContents.map((data, i) => {
        return <Profile content={data} key={i} />;
      })}
      <Divider title="contact us." />
      <ContactUs />
    </div>
  );
}
const contents = [
  // {
  //   title: '코인노트',
  //   since: 'since 2025.04',
  //   src: '/coinnote.mp4',
  //   type: 'video',
  //   description:
  //     'Type : 앱\n\n코인 투자에 관심이 생기고 나서 다양한 방식의 투자를 2년 정도하며 직접 느꼈던 정보를 얻는 것의 어려움을 해결하기 위해서 만들게 된 서비스입니다.',
  //   link: 'https://www.coin-note.site',
  // },
  {
    title: '롤링페이퍼',
    since: 'since 2020.08',
    src: '/rollingpaper.mp4',
    type: 'video',
    description:
      'User : 누적 약 740만명\n\nType : 웹/앱\n\n2020년 8월에 런칭하여, 현재까지 꾸준히 많은 사용자들이 사랑해주고 있는 서비스입니다. 한국을 넘어, 글로벌하게 사용되고 있습니다.',
    link: 'https://rollingpaper.site',
  },
  {
    title: '막차',
    since: 'since 2019.10',
    src: '/makkcha.mp4',
    type: 'video',
    description:
      'User : 약 5만명\n\nType : 앱\n\n막차는 우리의 일상 속에서 빈번하게 등장하는 불편함입니다. \n그리고 그 불편함은 막차를 찾는 과정에서 존재하였습니다. \n\n빈번하게 존재하는 불편함이지만, 아직 제대로 해결되지 않은 이 문제를 저희만의 방식으로 풀어내고 싶었습니다.\n\n현재는 서비스를 종료하였습니다.',
    link: '',
  },
  // {
  //   title: 'deathnote.gg',
  //   since: 'coming 2021.01',
  //   src: '/deathnote_gg.png',
  //   type: 'image',
  //   description:
  //     'Type : 웹 서비스\n\nStatus : 프로토 타입\n\n현재 천천히 개발 진행중인 왼손잡이들의 새로운 야심작입니다. LOL을 굉장히 즐겨하는데, 그러던 와중 떠오른 아이디어로 프로토타입까지는 개발을 마친 상태입니다. \n\nLOL을 조금이라도 해보았던 사람은 정말 좋아할만한 서비스입니다.\n\n2021년 1월에 런칭을 목표로 하고 있습니다.',
  //   link: '',
  // },
];

const profileContents = [
  {
    name: '류길종',
    position: 'Leader',
    description: `사람들에게 의미 있는 서비스를 만들고 싶은 마음 하나로 이 길에 들어섰습니다.
대학 시절부터 여러 프로젝트를 경험하며 시행착오를 겪었고, 그 과정 속에서 무엇이 진짜 가치인지 고민하게 되었습니다.
앞으로도 끝까지 도전해보려 합니다.`,
  },
  {
    name: '강성찬',
    position: 'Lead Developer',
    description: `문제를 해결하는 과정에 흥미를 느끼는 개발자입니다.
기술은 결국 사람을 위한 것이라 생각하며, 사용자 중심의 코드를 지향합니다.
꾸준히, 차근차근 나아가고 싶습니다.`,
  },
];

export default App;
